<div class="container-course">
	<section class="header-education">
		<div class="container_education">
			<div class="header-education__inner">
				<a href="/education" class="header-education__btn-back">
					<img class="header-education__icon-back" src="assets/images/education/icons/icon__back-arrow.svg"
						 alt="">
					Назад
				</a>

				<a href="/">
					<img class="logo" src="assets/images/education/icon__logo.svg" alt="">
				</a>
			</div>
		</div>
	</section>

	<section class="hero">
		<div class="container_education">

			<div class="hero__inner">

				<div class="hero__content">
					<h1 class="hero__title">Знакомьтесь, креатив</h1>
					<h2 class="hero__subtitle"><span>Креативщик</span> — это тот, кто...</h2>
				</div>

				<div class="hero__characteristics">
					<div class="hero__item">облекает рациональные задачи клиента в креативную оболочку</div>
					<div class="hero__item">придумывает креативные идеи и концепции</div>
					<div class="hero__item">придает идеям форму (визуальную, текстовую, звуковую и т.п.)</div>
					<div class="hero__item">презентует их без потери смысла и целостности разным людям: от коллег в
						агентстве до клиента, подрядчиков и, в конце концов, аудитории
					</div>
					<div class="hero__item">следит за воплощением креатива в жизнь</div>
				</div>
			</div>
		</div>
	</section>

	<section class="characteristic">
		<div class="container_education">
			<h2 class="section-title characteristic__title">Ты нам подходишь, если ты:</h2>
			<div class="tabs">
				<div class="tabs__element" *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="selectedTab === tab">
					{{ tab.title }}
				</div>
			</div>

			<div class="tab-content">
				<ng-container *ngIf="selectedTab">
					<div class="characteristic__inner">
						<div class="characteristic__card" *ngFor="let data of selectedTab.content">
							<img class="characteristic__icon"
								 src="assets/images/education/course-page/{{data.icon}}" alt="">
							<div class="characteristic__text">{{data.text}}</div>
						</div>
					</div>
				</ng-container>
			</div>
		</div>
	</section>

	<section class="curators">
		<div class="container_education">
			<h2 class="section-title section-title--black curators__title">Наши кураторы:</h2>
			<div class="curators__inner curators__inner--mobile">
				<div class="curators__card" *ngFor="let data of curatorsList" id={{data.id}}>
					<div class="curators__animation-photo">
						<img *ngIf="data.image_path" class="curators__photo"
							 src="{{environment.url}}{{data.image_path}}" alt="">
						<img *ngIf="!data.image_path" class="curators__photo"
							 src="assets/images/education/course-page/photo__curator.png" alt="">
					</div>
					<div class="curators__name">{{ data.name }}</div>
				</div>
			</div>

			<div class="swiper-container curators__slider">
				<div class="swiper-wrapper">
					<div class="swiper-slide curators__card" *ngFor="let data of curatorsList">
						<div class="curators__animation-photo">
							<img *ngIf="data.image_path" class="curators__photo"
								 src="{{environment.url}}{{data.image_path}}" alt="">
							<img *ngIf="!data.image_path" class="curators__photo"
								 src="assets/images/education/course-page/photo__curator.png" alt="">
						</div>
						<div class="curators__name">{{ data.name }}</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="active-courses">
		<div class="container_education">
			<h2 class="section-title active-courses__title">Открытые стажировки</h2>

			<div class="active-courses__inner">
				<div *ngFor="let data of internshipsDirections">
					<app-course-card [data]="data"
									 [idDirection]="idCourse"
									 [course]="true">
					</app-course-card>
				</div>
			</div>
		</div>
	</section>

	<section class="line-text">
		<div class="line-text__inner">
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
		</div>
		<div aria-hidden="true" class="line-text__inner">
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--bold">Подпишись на анонсы стажировок</div>
			<div class="line-text__item line-text__item--stroke">Подпишись на анонсы стажировок</div>
		</div>
	</section>

	<app-form-new-course></app-form-new-course>
</div>

<app-successful-sending></app-successful-sending>
<app-take-test></app-take-test>
